import React from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';
import ParticleGrid from '../../ParticleGrid';
import Post1 from '../../data/posts/Hello_World';
import Post2 from '../../data/posts/btc';
import Post3 from '../../data/posts/convergence';

const BlogList = () => {
    const posts = [
        { id: 'convergence', date: Post3.date, title: 'The Great Convergence', post: Post3 },
        { id: 'btc', date: Post2.date, title: 'Energetic Essence', post: Post2 },
        { id: 'hello-world', date: Post1.date, title: 'raison d\'être', post: Post1 }
    ];

    return (
      <>
      <ParticleGrid />
      <div className="blog-list" style={{ position: 'relative', zIndex: 1 }}>
        <div className="terminal-window">
          <div className="terminal-header">
            <span className="terminal-title">C12://BLOG</span>
            <div className="terminal-controls">
              <span className="terminal-control">_</span>
              <span className="terminal-control">□</span>
              <span className="terminal-control">×</span>
            </div>
          </div>
          <div className="terminal-content">
            <p className="terminal-line">
              <span className="terminal-prompt">$</span> ls -la ./posts/
            </p>
            <p className="terminal-line">
              total {posts.length} posts
            </p>
            {posts.map((post, index) => (
              <Link to={`/blog/${post.id}`} key={post.id} className="blog-item" style={{ textDecoration: 'none', display: 'block' }}>
                <p className="terminal-line" style={{ margin: 0 }}>
                  <span className="terminal-prompt">-rw-r--r--</span>
                  <span style={{ marginLeft: '1rem' }}>{post.date}</span>
                  <span style={{ marginLeft: '1rem' }}>{post.title}</span>
                </p>
              </Link>
            ))}
            <div className="terminal-input">
          <Link to="/">
                <button className="terminal-button">[HOME]</button>
          </Link>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  };
  
  export default BlogList;
